import React, { useEffect, useState } from 'react'
import AdminServiceV2 from '../../../../services/admin.service.v2';
import { Button, Form, Modal, Table } from 'react-bootstrap';
import Select from "react-select"
import toast from 'react-hot-toast';

interface IMhcetMapping {
    refreshExam: () => void
    examId: any
    exam: any
}

export default function ShiftDBMapping(props: IMhcetMapping) {
    const [loading, setLoading] = useState(false);
    const [selectedShift, setSelectedShift] = useState<string>('');
    const [dbName, setDbName] = useState<string>('');

    async function handleMapShift() {
        if (!dbName || !selectedShift) {
            toast.error("Please enter DB Name");
            return;
        }
        setLoading(true);
        await AdminServiceV2.mapShiftToDB(props.examId, selectedShift, { verificationDb: dbName })
            .then((res) => {
                if (res.status === 200) {
                    toast.success("Shift Mapped Successfully");
                    setSelectedShift('');
                    setDbName('');
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || "Unable to Map Shift");
            })
            .finally(() => {
                setLoading(false);
                setSelectedShift('');
                setDbName('');
                props.refreshExam();
            })
    }

    return (
        <div className="p-3">

            <Table bordered hover size="sm">
                <thead>
                    <tr>
                        <th>Shift</th>
                        <th>Shift ID</th>
                        <th>Verification DB</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.exam?.shifts?.map((shift: any) => (
                            <tr>
                                <td>{shift?.shiftName || "-"}</td>
                                <td>{shift?._id || "-"}</td>
                                <td>{shift?.verificationDb || "-"}</td>
                                <td>
                                    <Button variant='primary' size='sm' onClick={() => setSelectedShift(shift._id)}>
                                        Map
                                    </Button>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>

            <Modal show={selectedShift !== ''} onHide={() => setSelectedShift('')}>
                <Modal.Body>
                    <div className="d-flex justify-content-between">
                        Map Shift
                    </div>

                    <Form.Group>
                        <Form.Label>DB Name</Form.Label>
                        <Form.Control
                            type='text'
                            value={dbName}
                            onChange={(e) => setDbName(e.target.value)}
                        />
                    </Form.Group>
                    <div className='d-flex justify-content-end align-items-center mt-2'>
                        <Button size='sm' className="xcn-text-12 xcn-fw-600 m-1" onClick={handleMapShift} disabled={loading}>
                            {
                                loading ? "Mapping..." : "Map"
                            }
                        </Button>
                    </div>

                </Modal.Body>
            </Modal>
        </div>
    );
}